import { useQuery } from '@tanstack/react-query';
import { loadProductCatalogFilters } from '../pages/AdminPanel/Products/service/product-catalog-filters-service';
import { CATALOG_FILTERS_SUBCOLLECTION } from '../constants/productCatalogFilters';

export function useProductCatalogFilters(collectionName, docId, enabled = true) {
  return useQuery({
    queryKey: [collectionName, docId, CATALOG_FILTERS_SUBCOLLECTION],
    queryFn: () => loadProductCatalogFilters(collectionName, docId),
    enabled: !!collectionName && !!docId && enabled,
    staleTime: 1000 * 60 * 5,
  });
}
